import { Component, ContentChildren, EventEmitter, Output, QueryList } from '@angular/core';
import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { MSidebarMenuItemComponent } from './sidebar-menu-item.component';

@Component({
  selector: 'm-sidebar-menu',
  template: `
    <nz-tabset
      class="m-sidebar-menu-tabset"
      nzTabPosition="left"
      [class.tabset-hide]="!this.selectedTab"
      [(nzSelectedIndex)]="selectedIndex"
    >
      <nz-tab *ngFor="let tab of allTabs" [nzTitle]="tabTitle" (nzClick)="onSelect(tab)">
        <ng-template #tabTitle>
          <i nz-icon nz-tooltip [nzType]="tab.mTabIcon" nzTheme="outline" nzTooltipPlacement="right" [nzTooltipTitle]="tab.mTabTitle"></i>
        </ng-template>
      </nz-tab>
    </nz-tabset>
    <div class="m-sidebar-menu-content" *ngIf="this.selectedTab">
      <div class="m-sidebar-menu-content-header">
        <ng-container *ngTemplateOutlet="selectedTab.header"></ng-container>
        <i class="m-sidebar-menu-content-icon-close" nz-icon nzType="close" nzTheme="outline" (click)="onClose()"></i>
      </div>
      <div class="m-sidebar-menu-content-body">
        <ng-container *ngTemplateOutlet="selectedTab.content"></ng-container>
      </div>
    </div>
  `,
  host: {
    class: 'm-sidebar-menu'
  }
})
export class MSidebarMenuComponent {
  @ContentChildren(MSidebarMenuItemComponent, { descendants: true })
  allTabs: QueryList<MSidebarMenuItemComponent> = new QueryList<MSidebarMenuItemComponent>();
  selectedTab: NzSafeAny = null;
  selectedIndex = 0;

  @Output() readonly mClose = new EventEmitter<void>();

  onSelect(tab: MSidebarMenuItemComponent): void {
    this.selectedTab = tab;
  }

  onClose(): void {
    this.selectedTab = null;
    this.mClose.emit();
  }
}
